import { ApiResponse } from 'src/types/api-response';
import { HTBaiViet, HTBaiVietTheLoai, HTBaiVietTheLoaiApi } from 'src/types/htblog';
import { authApiService } from './auth-api';
import { apiGet, apiPost, apiDelete, apiClient } from './api-client';

// ----------------------------------------------------------------------
// BLOG API SERVICE
// ----------------------------------------------------------------------

export const blogAPI = {
  async listBaiViet(): Promise<ApiResponse<HTBaiViet>> {
    return apiGet<ApiResponse<HTBaiViet>>(
      '/BaiViet/ListBaiViet',
      'BaiViet',
      'Lấy danh sách bài viết thất bại. Vui lòng thử lại.'
    );
  },

  async getBlogById(id: number): Promise<ApiResponse<HTBaiViet>> {
    return apiGet<ApiResponse<HTBaiViet>>(
      `/BaiViet/BaiViet/${id}`,
      'BaiViet',
      'Lấy thông tin bài viết thất bại. Vui lòng thử lại.'
    );
  },

  async createBlog(model: any, file?: File): Promise<ApiResponse<HTBaiViet>> {
    // eslint-disable-next-line no-useless-catch
    try {
      const currentUser = await authApiService.getCurrentUser();
      
      if (currentUser?.oneItem?.htTaiKhoan?.id) {
        model.taiKhoanId = currentUser.oneItem.htTaiKhoan.id;
      }

      const formData = new FormData();
      formData.append('TheLoaiId', model.theLoaiId.toString());
      formData.append('TaiKhoanId', model.taiKhoanId || '');
      formData.append('TieuDe', model.tieuDe);
      formData.append('NoiDung', model.noiDung);
      formData.append('MoTaNgan', model.moTaNgan);
      formData.append('TrangThai', model.trangThai.toString());
      if (file) {
      formData.append('file', file);
    }
      return await apiPost<ApiResponse<HTBaiViet>>(
        '/BaiViet/AddBaiViet',
        formData,
        'BaiViet',
        true,
        'Thêm bài viết thất bại. Vui lòng thử lại.'
      );
    } catch (error: any) {
      throw error;
    }
  },

  async editBlog(id: number, model: any, file?: File): Promise<ApiResponse<HTBaiViet>> {
    const formData = new FormData();
    formData.append('TheLoaiId', model.theLoaiId.toString());
    formData.append('TaiKhoanId', model.taiKhoanId || '');
    formData.append('TieuDe', model.tieuDe);
    formData.append('NoiDung', model.noiDung);
    formData.append('MoTaNgan', model.moTaNgan);
    formData.append('TrangThai', model.trangThai.toString());
    
    if (file) {
      formData.append('file', file);
    }

    return apiPost<ApiResponse<HTBaiViet>>(
      `/BaiViet/EditBaiViet/${id}`,
      formData,
      'BaiViet',
      true,
      'Cập nhật bài viết thất bại. Vui lòng thử lại.'
    );
  },

  async deleteBlog(ids: number | number[]): Promise<ApiResponse<HTBaiViet>> {
    const idArray = Array.isArray(ids) ? ids : [ids];
    
    return apiPost<ApiResponse<HTBaiViet>>(
      '/BaiViet/DeleteBaiViet',
      { ids: idArray },
      'BaiViet',
      false,
      'Xóa bài viết thất bại. Vui lòng thử lại.'
    );
  }
};

// ----------------------------------------------------------------------
// ARTICLE CATEGORY API SERVICE
// ----------------------------------------------------------------------

export const article_categoryAPI = {
  async listBaiVietTheLoai(): Promise<ApiResponse<HTBaiVietTheLoai>> {
    return apiGet<ApiResponse<HTBaiVietTheLoai>>(
      '/BaiViet/ListBaiVietTheLoai',
      'BaiViet',
      'Lấy danh sách bài viết thể loại thất bại. Vui lòng thử lại.'
    );
  },

  async getBaiVietTheLoaiById(id: number): Promise<ApiResponse<HTBaiVietTheLoai>> {
    return apiGet<ApiResponse<HTBaiVietTheLoai>>(
      `/BaiViet/BaiVietTheLoai/${id}`,
      'BaiViet',
      'Lấy thông tin bài viết thể loại thất bại. Vui lòng thử lại.'
    );
  },

  async addBaiVietTheLoai(model: HTBaiVietTheLoaiApi): Promise<ApiResponse<HTBaiVietTheLoai>> {
    return apiPost<ApiResponse<HTBaiVietTheLoai>>(
      '/BaiViet/AddBaiVietTheLoai',
      model,
      'BaiViet',
      false,
      'Thêm bài viết thể loại thất bại. Vui lòng thử lại.'
    );
  },

  async editBaiVietTheLoai(id: number, model: HTBaiVietTheLoaiApi): Promise<ApiResponse<HTBaiVietTheLoai>> {
    return apiPost<ApiResponse<HTBaiVietTheLoai>>(
      `/BaiViet/EditBaiVietTheLoai/${id}`,
      model,
      'BaiViet',
      false,
      'Cập nhật bài viết thể loại thất bại. Vui lòng thử lại.'
    );
  },

  async deleteBaiVietTheLoai(ids: number[]): Promise<ApiResponse<HTBaiVietTheLoai>> {
    return apiPost<ApiResponse<HTBaiVietTheLoai>>(
      '/BaiViet/DeleteBaiVietTheLoai',
      { ids },
      'BaiViet',
      false,
      'Xóa bài viết thất bại. Vui lòng thử lại.'
    );
  }
};